/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Commits_ConfirmInputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Team_Share_No_Commits_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_commits_confirm = /** @type {((inputs?: Team_Share_No_Commits_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Commits_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OK")
	if (locale === "de") return /** @type {LocalizedString} */ ("OK")
	if (locale === "it") return /** @type {LocalizedString} */ ("OK")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ХОРОШО")
	if (locale === "es") return /** @type {LocalizedString} */ ("DE ACUERDO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("好的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("わかりました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("OK")
});